import { Arrow, ArrowUp } from "../../assets/images";
const productsEdificioResidencial = [
  {
    id: 0,
    name: "Subir",
    environmentArea: 0,
    category: { image: ArrowUp },
    pinPos: [310, 337, -61],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 314.98858959613983,
        y: 650.1742480495607,
        z: -69.58620861537187,
      },
      target: {
        x: 294.32783210205434,
        y: 638.5266933326376,
        z: -103.97560125467244,
      },
      posMobile: {
        x: 314.98858959613983,
        y: 650.1742480495607,
        z: -69.58620861537187,
      },
      targetMobile: {
        x: 294.32783210205434,
        y: 638.5266933326376,
        z: -103.97560125467244,
      },
    },
    cameraOut: {
      pos: {
        x: 314.98858959613983,
        y: 650.1742480495607,
        z: -69.58620861537187,
      },
      target: {
        x: 294.32783210205434,
        y: 638.5266933326376,
        z: -103.97560125467244,
      },
    },
  },
  {
    id: -1,
    name: "Descer",
    environmentArea: 0,
    category: { image: Arrow },
    pinPos: [311, 420, -600],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 84.50369154431179,
        y: 230.68183835456134,
        z: 214.4330955821151,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
      posMobile: {
        x: 84.50369154431179,
        y: 230.68183835456134,
        z: 214.4330955821151,
      },
      targetMobile: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
    cameraOut: {
      pos: {
        x: 84.50369154431179,
        y: 230.68183835456134,
        z: 214.4330955821151,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },

  {
    id: 1,
    pinPos: [355.540159526682, 435.17014540908326, -379.79267135621404],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 116.43982148605579,
        y: 393.1813171204079,
        z: -107.43784884376278,
      },
      target: {
        x: 116.94065388651487,
        y: 393.3001410386033,
        z: -108.29519812096262,
      },
      posMobile: {
        x: 116.43982148605579,
        y: 393.1813171204079,
        z: -107.43784884376278,
      },
      targetMobile: {
        x: 116.94065388651487,
        y: 393.3001410386033,
        z: -108.29519812096262,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 2,
    pinPos: [344.0400751924547, 630.1274035368011, -300.11738561218897],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 234.11256168480443,
        y: 469.874125346434,
        z: -24.4593222178393,
      },
      target: {
        x: 234.2694054513116,
        y: 470.3630114077974,
        z: -25.317454172676356,
      },
      posMobile: {
        x: 234.11256168480443,
        y: 469.874125346434,
        z: -24.4593222178393,
      },
      targetMobile: {
        x: 234.2694054513116,
        y: 470.3630114077974,
        z: -25.317454172676356,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },

  {
    id: 3,
    environmentArea: 0,
    pinPos: [182.194816841785, 640.8809654756279, -1013.4902746862242],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 350.2337966022459,
        y: 640.1073598965729,
        z: -571.2597450170049,
      },
      target: {
        x: 349.75540594247263,
        y: 640.1271564439539,
        z: -572.1376689734803,
      },
      posMobile: {
        x: 350.2337966022459,
        y: 640.1073598965729,
        z: -571.2597450170049,
      },
      targetMobile: {
        x: 349.75540594247263,
        y: 640.1271564439539,
        z: -572.1376689734803,
      },
    },
    cameraOut: {
      pos: {
        x: 294.630474947191,
        y: 638.3676019585774,
        z: -102.97565483939529,
      },
      target: {
        x: 294.27438477689714,
        y: 638.4277443476473,
        z: -103.90816901283024,
      },
    },
  },
  {
    id: 4,
    pinPos: [139.94208921922854, 225.63613730741628, -602.5823940456048],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 106.18298221190888,
        y: 222.5958261014979,
        z: -290.3599423532382,
      },
      target: {
        x: 106.11087162881859,
        y: 222.60540252354264,
        z: -291.3572930217331,
      },
      posMobile: {
        x: 106.18298221190888,
        y: 222.5958261014979,
        z: -290.3599423532382,
      },
      targetMobile: {
        x: 106.11087162881859,
        y: 222.60540252354264,
        z: -291.3572930217331,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 5,
    pinPos: [213.49091433747085, 222.06787684523448, -283.826630792149],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 101.66981391813225,
        y: 263.8313073880926,
        z: -418.9559910589791,
      },
      target: {
        x: 102.40048485144047,
        y: 263.55333907023146,
        z: -418.33240978802564,
      },
      posMobile: {
        x: 101.66981391813225,
        y: 263.8313073880926,
        z: -418.9559910589791,
      },
      targetMobile: {
        x: 102.40048485144047,
        y: 263.55333907023146,
        z: -418.33240978802564,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 6,
    pinPos: [171.02950206098402, 25.636137307416266, -502.58239404560476],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 197.02452498978002,
        y: 269.60519119964755,
        z: -286.8841458484959,
      },
      target: {
        x: 196.77194991479686,
        y: 268.8391467565286,
        z: -287.47523107303107,
      },
      posMobile: {
        x: 197.02452498978002,
        y: 269.60519119964755,
        z: -286.8841458484959,
      },
      targetMobile: {
        x: 196.77194991479686,
        y: 268.8391467565286,
        z: -287.47523107303107,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },

  {
    id: 7,
    pinPos: [-213.34423462128828, 26.618191572519876, 198.51818365835496],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 148.4833865825966,
        y: 200.53123945020334,
        z: 167.91481274080195,
      },
      target: {
        x: 147.60844882327223,
        y: 200.10780619387373,
        z: 168.14973441869174,
      },
      posMobile: {
        x: 148.4833865825966,
        y: 200.53123945020334,
        z: 167.91481274080195,
      },
      targetMobile: {
        x: 147.60844882327223,
        y: 200.10780619387373,
        z: 168.14973441869174,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },

  {
    id: 8,
    environmentArea: 0,
    pinPos: [283.71404592010964, 421.1269351665455, -853.1794410365075],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 234.03479277547564,
        y: 582.0209021908722,
        z: -684.7009127211803,
      },
      target: {
        x: 234.09756844616896,
        y: 581.3552375289482,
        z: -685.444518647081,
      },
      posMobile: {
        x: 234.03479277547564,
        y: 582.0209021908722,
        z: -684.7009127211803,
      },
      targetMobile: {
        x: 234.09756844616896,
        y: 581.3552375289482,
        z: -685.444518647081,
      },
    },
    cameraOut: {
      pos: {
        x: 294.077353390815,
        y: 638.3608116910166,
        z: -102.71719196545219,
      },
      target: {
        x: 294.0942009002046,
        y: 638.0941633563082,
        z: -103.68083859520014,
      },
    },
  },

  {
    id: 9,
    environmentArea: 0,
    pinPos: [-117.32024051938555, 842.0393193034913, -386.4652661480556],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -288.81601840443784,
        y: 619.0845113501906,
        z: -253.637486583792,
      },
      target: {
        x: -288.3801389326013,
        y: 619.8035477248516,
        z: -254.17877742792842,
      },
      posMobile: {
        x: -288.81601840443784,
        y: 619.0845113501906,
        z: -253.637486583792,
      },
      targetMobile: {
        x: -288.3801389326013,
        y: 619.8035477248516,
        z: -254.17877742792842,
      },
    },
    cameraOut: {
      pos: {
        x: 295.0182686465625,
        y: 638.5245159715174,
        z: -103.74478657993158,
      },
      target: {
        x: 294.12141956954326,
        y: 638.4233974497192,
        z: -104.1754102875919,
      },
    },
  },

  {
    id: 10,
    pinPos: [131.25122894535886, 825.9022494190533, -238.30306716917454],
    animationSpeed: 0.1,
    scale: 1.3,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -0.10148754243821824,
        y: 493.7005566231089,
        z: -57.1307983356009,
      },
      target: {
        x: 0.004415803627203333,
        y: 494.5769527869309,
        z: -57.600600682689766,
      },
      posMobile: {
        x: -0.10148754243821824,
        y: 493.7005566231089,
        z: -57.1307983356009,
      },
      targetMobile: {
        x: 0.004415803627203333,
        y: 494.5769527869309,
        z: -57.600600682689766,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 11,
    pinPos: [-228.1793446769697, 355.52019286277454, -298.0940378177445],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -305.1280783259427,
        y: 208.277796811099,
        z: -78.75393336793167,
      },
      target: {
        x: -305.01257634802056,
        y: 208.82762114118572,
        z: -79.58118937373686,
      },
      posMobile: {
        x: -305.1280783259427,
        y: 208.277796811099,
        z: -78.75393336793167,
      },
      targetMobile: {
        x: -305.01257634802056,
        y: 208.82762114118572,
        z: -79.58118937373686,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 12,
    pinPos: [-357.7922694367982, 242.4628969825785, -414.2860073054396],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -86.90906859448638,
        y: 199.4076166039667,
        z: -135.06140776478262,
      },
      target: {
        x: -87.70039749942529,
        y: 199.5446692820291,
        z: -135.65723922387494,
      },
      posMobile: {
        x: -86.90906859448638,
        y: 199.4076166039667,
        z: -135.06140776478262,
      },
      targetMobile: {
        x: -87.70039749942529,
        y: 199.5446692820291,
        z: -135.65723922387494,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24713515430577,
        y: 230.6802043243184,
        z: 174.9689810183385,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
];

export default productsEdificioResidencial;
